import { AppDataActions, AppDataSelectors } from '../../redux/app-data';
import { WSMessage } from './ws-message';

/**
 * @property {KBetOfferOddsRemovedMessage} message
 */
export class BetOfferOddsRemovedMessage extends WSMessage {

  isRelevant(state) {
    const { eventId, outcomes } = this.message.boor;
    const eventsMap = AppDataSelectors.selectEventsMap(state);

    if (eventId in eventsMap && eventsMap[eventId]) {
      const betOffersMap = AppDataSelectors.selectBetOffersMap(state);
      const outcomesMap = AppDataSelectors.selectOutcomesMap(state);

      this.actions = outcomes
        .filter((outcome) => {
          const isBetOfferInState = outcome.betOfferId in betOffersMap && betOffersMap[outcome.betOfferId];
          const isOutcomeInState = outcome.id in outcomesMap && outcomesMap[outcome.id];
          return isBetOfferInState && isOutcomeInState;
        })
        .map((outcome) => AppDataActions.removeBetOfferOdds(outcome));

      return (this.actions.length > 0);
    }
    return false;
  }
}
